export default __webpack_public_path__ + "static/media/Enten-beim-Entenhaus.c70ab5bd.png";